import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const distanceTravelledState = (state: RootState) => state.scene.dashboard.distanceTravelledState;

export const getDistanceTravelledDrillDownViewState = createSelector(
  distanceTravelledState,
  ({ viewState }) => viewState
);

export const getDistanceTravelledDrillDownTotalFilteredRecords = createSelector(
  distanceTravelledState,
  ({ totalFilteredRecords }) => totalFilteredRecords
);

export const getDistanceTravelledDrillDownTotalRecords = createSelector(
  distanceTravelledState,
  ({ totalRecords }) => totalRecords
);

export const getDistanceTravelledDrillDownCustomDateRange = createSelector(
  distanceTravelledState,
  ({ drillDownCustomDateRange }) => drillDownCustomDateRange
);

export const getDistanceTravelledDrillDownScope = createSelector(
  distanceTravelledState,
  ({ drillDownScope }) => drillDownScope
);

export const getDistanceTravelledDrillDownConfiguration = createSelector(
  distanceTravelledState,
  ({ configuration }) => configuration
);

export const isDistanceTravelledDrillDownLoading = createSelector(
  distanceTravelledState,
  ({ loading }) => loading
);
